<template>
  <UiDialog v-if="isTerminalLocationAvailable" :value="locationState.permissionRequested" :title="$t('开启终端定位')" width="440px" :close-on-click-modal="false" @input="handleVisibility">
    <UiFormNotice>{{ $t("用于地图显示本机位置及坐标对齐，不上传、不保存位置轨迹。进入后台停止定位，返回前台自动恢复。") }}</UiFormNotice>
    <p>{{ $t("同意后将申请系统定位权限。已授权时直接获取位置；系统权限弹窗由操作系统提供。") }}</p>
    <template #footer>
      <UiButton action="confirm" @click="confirmPermission">{{ $t("同意并开启") }}</UiButton>
      <UiButton action="cancel" @click="cancelRequest">{{ $t("取消") }}</UiButton>
    </template>
  </UiDialog>
</template>

<script>
import { t } from '@/i18n'
import { terminalPosition, terminalPositionMixin, confirmTerminalLocationPermission, cancelTerminalLocationRequest } from '@/utils/terminalPosition'

export default {
  name: 'TerminalLocationPermissionDialog',
  mixins: [terminalPositionMixin],
  data () { return { locationState: terminalPosition } },
  watch: {
    'locationState.error' (message) { if (message && this.isTerminalLocationAvailable) this.$message.warning(t(message)) },
    $route () { this.cancelRequest() }
  },
  beforeDestroy () { this.cancelRequest() },
  methods: {
    confirmPermission: confirmTerminalLocationPermission,
    cancelRequest: cancelTerminalLocationRequest,
    handleVisibility (visible) { if (!visible) this.cancelRequest() }
  }
}
</script>
